'use strict';

var range = require('../../../_virtual/range.js_commonjs-exports.js');
require('./and.js');
require('./between.js');
require('./integer.js');
require('./helpers/isInteger.js');
require('./helpers/wrapValidator.js');
var between = require('../../../_virtual/between.js_commonjs-exports.js');
var integer = require('../../../_virtual/integer.js_commonjs-exports.js');
var isInteger = require('../../../_virtual/isInteger.js_commonjs-exports.js');
var wrapValidator = require('../../../_virtual/wrapValidator.js_commonjs-exports.js');
var and = require('../../../_virtual/and.js_commonjs-exports.js');

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = range;

var _and = _interopRequireDefault(and.__exports);

var _between = _interopRequireDefault(between.__exports);

var _integer = _interopRequireDefault(integer.__exports);

var _isInteger = _interopRequireDefault(isInteger.__exports);

var _wrapValidator = _interopRequireDefault(wrapValidator.__exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
/* istanbul ignore next */
Math.pow(2, 53) - 1;

function isValidLength(x) {
  return (0, _isInteger["default"])(x) && Math.abs(x) < MAX_SAFE_INTEGER;
}

function range(min, max) {
  if (!isValidLength(min) || !isValidLength(max)) {
    throw new RangeError("\"range\" requires two integers: ".concat(min, " and ").concat(max, " given"));
  }

  if (min === max) {
    throw new RangeError('min and max must not be the same');
  }

  return (0, _wrapValidator["default"])((0, _and["default"])([(0, _integer["default"])(), (0, _between["default"])({
    gte: min,
    lt: max
  })], 'range'), 'range', {
    min: min,
    max: max
  });
}

}(range.__exports));
